import type { FieldConfig } from '@app/src/pages/TabularImport/shared/fieldConfig'
import type { TabularImportEntityType } from '@app/src/types/tabularImport'
import React, { createContext, useContext, useMemo } from 'react'

export type TabularImportEntityContextValue = {
  entityType: TabularImportEntityType
  fieldConfigs: FieldConfig[]
  requiredFields: readonly string[]
}

const TabularImportEntityContext = createContext<TabularImportEntityContextValue | null>(null)

export const TabularImportEntityProvider: React.FC<React.PropsWithChildren<TabularImportEntityContextValue>> = ({
  entityType,
  fieldConfigs,
  requiredFields,
  children,
}) => {
  const value = useMemo(
    () => ({ entityType, fieldConfigs, requiredFields }),
    [entityType, fieldConfigs, requiredFields],
  )
  return <TabularImportEntityContext.Provider value={value}>{children}</TabularImportEntityContext.Provider>
}

export function useTabularImportEntity(): TabularImportEntityContextValue {
  const value = useContext(TabularImportEntityContext)
  if (!value) throw new Error('useTabularImportEntity must be used inside a TabularImportEntityProvider')
  return value
}
